const Logo = () => (
  <a href="/" className="flex items-center gap-2.5 group">
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" className="transition-transform duration-300 group-hover:scale-105">
      <rect x="0" y="2" width="14" height="6" rx="1.5" fill="#7c3aed" />
      <rect x="16" y="2" width="20" height="6" rx="1.5" fill="#6d28d9" />
      <rect x="0" y="10" width="9" height="6" rx="1.5" fill="#6d28d9" />
      <rect x="11" y="10" width="12" height="6" rx="1.5" fill="#7c3aed" />
      <rect x="25" y="10" width="11" height="6" rx="1.5" fill="#6d28d9" />
      <rect x="0" y="18" width="16" height="6" rx="1.5" fill="#7c3aed" />
      <rect x="18" y="18" width="18" height="6" rx="1.5" fill="#6d28d9" />
      <rect x="0" y="26" width="10" height="6" rx="1.5" fill="#6d28d9" />
      <rect x="12" y="26" width="13" height="6" rx="1.5" fill="#7c3aed" />
      <rect x="27" y="26" width="9" height="6" rx="1.5" fill="#6d28d9" />
    </svg>
    <span className="text-lg font-bold tracking-tight text-stone-900 leading-none">
      saleswall<span className="text-violet-700">.ai</span>
    </span>
  </a>
);

export { Logo };
